import { CHAT_LAUNCHER_RESERVE } from "@/components/chat/SidebarChat/chatWidgetLayout";

/**
 * Trailing space at the end of a scrollable page, so its last row can be
 * scrolled out from under the collapsed chat pill in the bottom-right corner.
 *
 * Render this as the final child of the scrolled content — never as padding on
 * the scroll container itself, and never on the 100vh column in `BuildingLayout`
 * (which is where this reserve used to live, and why the pages below it were
 * capped short of the window with a blank band they could not scroll into).
 * As in-flow content it scrolls away with everything else, so the list and its
 * scrollbar still run the full height of the window.
 */
export function ChatLauncherSpacer() {
  return <div aria-hidden="true" className="shrink-0" style={{ height: CHAT_LAUNCHER_RESERVE }} />;
}
